export default __webpack_public_path__ + "static/flipImg4-d2d954da5a83203bff8aaa5452e4829d.webp";